
import styled from "styled-components";

export const FormContainer = styled.div`
`;

export const FormHeader = styled.h2`
  margin-bottom: 20px;
  text-align: center;
  font-size: 24px;
  color: #333333;
  font-weight: bold;
`;

export const FormField = styled.div`
  margin-bottom: 20px;

  label {
    display: block;
    font-weight: bold;
    margin-bottom: 8px;
    color: #333333;
  }

  input,
  select,
  textarea {
    width: 100%;
    padding: 12px 15px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 16px;
    box-sizing: border-box;
    transition: all 0.3s ease;
    font-family: inherit;

    &:focus {
      border-color: #2f2f2f;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
      outline: none;
    }

    &:hover {
      border-color: #1a1a1a;
    }
  }

  textarea {
    resize: vertical;
    min-height: 80px;
  }

  select {
    appearance: none; /* Remove a seta padrão do select */
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%231ABC9C' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 12px;
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 12px 20px;
  background-color: #2f2f2f;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #1a1a1a;
  }

  &:disabled {
    background-color: #bdc3c7;
    cursor: not-allowed;
  }
`;

export const Message = styled.p`
  font-size: 14px;
  margin-top: 20px;
  color: ${(props) => (props.isError ? "#1a1a1a" : "#595959")};
  text-align: center;
`;

export const ValidationError = styled.span`
  color: #1a1a1a;
  font-size: 12px;
  margin-top: 5px;
  display: block;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;
  flex-wrap: wrap;
`;

export const NaoEntregueButton = styled.button`
  flex: 1;
  min-width: 150px;
  padding: 12px 20px;
  background-color: #ffffff;
  color: #333333;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #f5f5f5;
    border-color: #999;
  }

  &:disabled {
    background-color: #f5f5f5;
    color: #999;
    cursor: not-allowed;
    border-color: #ddd;
  }
`;

export const CancelButton = styled.button`
  flex: 1;
  min-width: 150px;
  padding: 12px 20px;
  background-color: #1a1a1a;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #2f2f2f;
  }

  &:disabled {
    background-color: #bdc3c7;
    cursor: not-allowed;
  }
`;

export const ConfirmButton = styled.button`
  flex: 1;
  min-width: 150px;
  padding: 12px 20px;
  background-color: #2f2f2f;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #1a1a1a;
  }

  &:disabled {
    background-color: #bdc3c7;
    cursor: not-allowed;
  }
`;
